// ** Type import
import { HorizontalNavItemsType } from 'src/@core/layouts/types'
import { userStorage } from 'src/utils/localStorage'

const navigationAdmin = (): HorizontalNavItemsType => {
    if (userStorage.isAdmin()) {
        return [
            {
                title: 'Administración',
                path: '/admin',
                icon: 'mdi:account-group-outline'
            },
            {
                title: 'Visualizador',
                path: '/grafo',
                icon: 'mdi:eye-outline'
            }

        ]
    } else {
        return []
    }
}

const navigation = (): HorizontalNavItemsType => [
    {
        title: 'Home',
        path: '/home',
        icon: 'mdi:home-outline'
    },

    {
        title: 'Dashboard',
        path: '/dashboard',
        icon: 'mdi:chart-line'
    },
    {
        title: 'Notificaciones',
        path: '/notifications',
        icon: 'mdi:bell-outline'
    },

    {
        title: 'Limites',
        path: '/limits',
        icon: 'mdi:chart-box-outline'
    },

    ...navigationAdmin()

    //   {
    //     title: 'Seguridad',
    //     path: '/security',
    //     icon: 'mdi:shield-outline'
    //   },
]

export default navigation
